/**
 * Privacy feature constants
 * All chain IDs, tokens, and UI constants for the privacy feature
 */

import { chainID } from '@polaris/core/namada'

export const PRIVACY_CHAINS = {
  PRIVACY_VAULT: chainID,
} as const

export const PRIVACY_VAULT_TO_ASSET = {
  chain: chainID,
  // OSMO via Noble on Namada
  token: 'ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B',
} as const

export const PRIVACY_UI = {
  POLARIS_LOGO: 'https://s3.polaris.app/polaris_logo_24x24.png',
} as const
